import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';
import {  BASE_URL_SANDBOX, GET_ALL_STATE ,BASE_URL_FOR_ELASTIC_SEARCH ,IS_ELASTIC_SEARCH_ON} from "../../../Constants/Config"

const initialState = {
    loading: false,
    isElasticConnected: "pending",
    allStateList: [],
    error: '',
    lastStateRequestAt: 0,
}


// Generate pening , fulfilled and rejected action type
export const fetchAllStates = createAsyncThunk(
    'allStates/fetchAllStates',
    async () => {
        try {
            const response = await axios.post(BASE_URL_SANDBOX + GET_ALL_STATE,  { headers: { "Content-Type": "multipart/form-data" } })

            if(response.status === 200){
                return response.data.result
            }
        } catch (error) {
            throw new Error(
                error?.response?.data?.message ||
                error?.message ||
                'Unable to retrieve states',
            );
        }
    },
    {
        condition: (_, { getState }) => {
            const state = getState()?.allStatesData;
            const stateList = state?.allStateList;
            const hasStates = Array.isArray(stateList) && stateList.length > 0;
            const requestedRecently =
                Date.now() - Number(state?.lastStateRequestAt || 0) < 30 * 1000;
            return !state?.loading && !hasStates && !requestedRecently;
        },
    },
)

export const CheckElasticConnection = createAsyncThunk(
    "allStates/CheckElasticConnection",
    async (data, { rejectWithValue }) => {
      try {
        if (IS_ELASTIC_SEARCH_ON) {
          const checkConnection = await axios.get(BASE_URL_FOR_ELASTIC_SEARCH, {
            timeout: 5000,
          });
          if (checkConnection && checkConnection.status === 200) {
            return true;
          }
        } else {
          return false;
        }
      } catch (error) {
        return null;
      }
    }
  );


const allStatesSlice = createSlice({
    name: 'allStates',
    initialState,
      extraReducers: (builder) => {
        builder.addCase(fetchAllStates.pending, (state) => {
            state.loading = true;
            state.lastStateRequestAt = Date.now();
        })
        builder.addCase(fetchAllStates.fulfilled, (state, action) => {
            state.loading = false;
            state.allStateList = action.payload;
            state.error = '';
        })
        builder.addCase(fetchAllStates.rejected, (state, action) => {
            state.loading = false;
            state.allStateList = {};
            state.error = action.error.message;
        })
        .addCase(CheckElasticConnection.fulfilled, (state, action) => {
            state.isElasticConnected = action.payload ?? false;
          });
               
    }
})


export default allStatesSlice.reducer
